import UseCaseCard from "./UseCaseCard";

const UseCaseGrid = ({ useCases, searchQuery, onView, onDownload }) => {
  return (
    <div 
      className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6"
      data-testid="usecase-grid"
    >
      {useCases.map((useCase) => (
        <UseCaseCard
          key={useCase.id}
          useCase={useCase}
          searchQuery={searchQuery}
          onView={() => onView(useCase)}
          onDownload={() => onDownload(useCase)}
        />
      ))}
    </div>
  );
};

export default UseCaseGrid;
